import React, {useState} from 'react';
import { Accordion, Form , Button} from 'react-bootstrap';
import { Modal } from 'react-bootstrap';
import axios from 'axios';
import { Alert } from 'react-bootstrap';

function TournoisParticiper(props) {
  const [error, setError] = useState(false);
  const [confirmation,setConfirmation] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [commentaire, setCommentaire] = useState()
  const apiUrl = process.env.REACT_APP_API_URL;



  
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setConfirmation(false);
    if(props.item.nombre_participants === props.item.nbr_equipe){
        setError("Tournoi complet");
        setIsLoading(false);
        return;
    }
    try {
      await axios.post(`${apiUrl}/tournois/participation/ajouter`, {
        commentaire : commentaire,
        idEquipe : props.userData.user.donnée.results[0].id_equipe,
        idTournois : props.item.id_tournoi
      }, {
        withCredentials: true
      });

      setError(null);
      setIsLoading(false);
      window.location.reload(); 

    } catch (error) {
      if (error.response) {
        setIsLoading(false)
        setError(error.response.data.message);
      } else {
        setIsLoading(false)
        setError(true);
      }
    }
  };




  return (
    <>
        {isLoading && 
          <div className="centered-content">
            <img src="/img/logo.png" alt="Logo" className="centered-logo" />
            <br/>
            <span className="loader"></span>
        </div>
    }
    <Accordion defaultActiveKey="0">
    {props.item && (
                        <>
                                <Accordion.Header>
                                    <div>
                                      <strong>{props.item.nomTournois} - {props.item.categorie}</strong>
                                      <hr/>
                                      Lieu : <strong>{props.item.localisation}</strong>
                                      <br/>
                                      Date du tournoi : <strong>{props.item.date}</strong>
                                      <br/>
                                      Nombres de participants : <strong>{props.item.nombre_participants} / {props.item.nbr_equipe} </strong>
                                    </div>
                                  </Accordion.Header>
                            <Accordion.Body>
                            {error && <Alert variant="danger">{error}</Alert>}
                            <div className="nom" style={{fontSize:"15px",fontWeight:'initial'}}>
                                           Tournois organisé par <a  href={`/coach/equipe/${props.item.id_equipe}`} target="_blank" rel="noopener noreferrer"><span style={{textTransform : 'capitalize'}}>{props.item.nom}</span></a> ({props.item.categorie})
                                           <br/>
                                           {props.item.nombre_participants === props.item.nbr_equipe && <strong>Tournoi Complet</strong>}
                            </div> 
                            <br/>
                            <Form.Label>Commentaire de l'équipe</Form.Label>
                            <Form.Control as="textarea" value={props.item.commentaire !== null ? (props.item.commentaire):('')} disabled  placeholder="Ajoutez un commentaire" rows={3} />
                            <br/>
                            <Form.Label>Commentaire (facultatif)</Form.Label>
                            <Form.Control as="textarea" value={commentaire} onChange={(e) => setCommentaire(e.target.value)} placeholder="Ajoutez un commentaire" disabled={props.item.nombre_participants === props.item.nbr_equipe} rows={3} />
                            <br/>
                            <div style={{textAlign:"right"}}>
                                <Button onClick={()=> setConfirmation(true)} variant="primary" style={{backgroundColor:"#00E676", borderColor:'#00E676'}} disabled={props.item.nombre_participants === props.item.nbr_equipe} >Participer</Button>
                            </div>   
                                    

                        </Accordion.Body>
                        {confirmation && (
                          <>
                            <Modal show={confirmation} onHide={() => {setConfirmation(false)}}>
                                    <Modal.Header closeButton>
                                      <Modal.Title>Participer au tournoi</Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                        Voulez-vous vraiment confirmer votre participation ?
                                    </Modal.Body>
                                    <Modal.Footer>
                                      <Button variant="secondary"  onClick={() => {setConfirmation(false)}} >
                                        Quitter
                                      </Button>
                                      <Button variant="primary" onClick={(e) => handleSubmit(e)} style={{backgroundColor:"#00E676", borderColor:'#00E676'}}  >
                                        Confirmer
                                      </Button>
                                    </Modal.Footer>
                            </Modal>
                          </>
                        )}
                    </>
            )}

    </Accordion>
    </>
  );
}

export default TournoisParticiper;